import styled from 'styled-components';

export const CreditsContainer = styled.article`
  min-width: 260px;
  margin-bottom: 30px;
  padding: 20px 25px;
  
  border: 1px solid #ebebeb;
  border-radius: 6px;
`;

export const CreditsHeader = styled.h2`
  margin: 0;
  margin-bottom: 5px;
  padding: 0;
  
  font-size: 24px;
  line-height: 30px;
`;

export const CreditsDate = styled.p`
  margin: 0;
  margin-bottom: 30px;
  padding: 0;
  
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
`;

export const CreditsAmount = styled.p`
  margin: 0;
  padding: 0;
  
  font-weight: 700;
  font-size: 24px;
  color: ${({ theme }) => theme.blue};
`;
